import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import HeroLuxury from "@/components/HeroLuxury";
import ToursLuxury from "@/components/ToursLuxury";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import Gallery from "@/components/Gallery";
import FAQ from "@/components/FAQ";
import ContactLuxury from "@/components/ContactLuxury";
import Footer from "@/components/Footer";
import PaymentSuccess from "@/components/PaymentSuccess";
import PaymentFailure from "@/components/PaymentFailure";
import AdminDashboard from "@/components/AdminDashboard";
import EFTPaymentInstructions from "@/components/EFTPaymentInstructions";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsOfService from "@/components/TermsOfService";
import CancellationPolicy from "@/components/CancellationPolicy";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <HeroLuxury />
        <ToursLuxury />
        <Services />
        <Testimonials />
        <Gallery />
        <FAQ />
        <ContactLuxury />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/payment-instructions" element={<EFTPaymentInstructions />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cancellation" element={<CancellationPolicy />} />
          <Route path="/disclaimer" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
